import React, { useCallback, useMemo } from 'react';
import axios from "axios";
import { GoogleMap, Marker, useJsApiLoader } from '@react-google-maps/api';

const containerStyle = {
  width: '100%',
  height: '300px'
};

const googleMapsApiKey = process.env.REACT_APP_GOOGLE_MAP_API_KEY;
const backendUrl = `https://${process.env.REACT_APP_API_DNS}/api/map`;

export const getLocationInfo = async (address) => {
  try {
    const response = await axios.get(backendUrl, {
      params: { address },
    });

    return response.data;
  } catch (error) {
    console.error("Error fetching location info:", error);
    return null;
  }
};

const GoogleMapContent = ({ lat, lng }) => {
  const { isLoaded } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: googleMapsApiKey
  });

  const center = useMemo(() => ({
    lat: lat ?? 37.7749,
    lng: lng ?? -122.4194
  }), [lat, lng]);
  
  const onLoad = useCallback((map) => {
      const bounds = new window.google.maps.LatLngBounds(center);
      map.fitBounds(bounds);
  }, [center]);

  return isLoaded? (
    <GoogleMap
      mapContainerStyle={containerStyle}
      center={center}
      zoom={12}
      onLoad={onLoad}
    >
      {lat && lng && <Marker position={center} />}
    </GoogleMap>
  ):(
    <p>Loading Map...</p>
  );
};

export default GoogleMapContent;